export default {
  // Common labels
  common: {
    welcome: 'Tere tulemast',
    totalPoints: 'Punkte kokku',
    points: 'Punkti',
    thisMonth: 'sel kuul',
    recentActivity: 'Viimased tegevused',
    loading: 'Laadimine...',
    tierProgress: '{points} punkti järgmise tasemeni',
    currentUser: 'Praegune',
    refresh: 'Värskenda',
    filter: 'Filtreeri',
    edit: 'Muuda',
  },

  // App title and tabs
  app: {
    title: 'GroceryMart Boonused',
    tabs: {
      home: 'Avaleht',
      profile: 'Profiil',
      leaderboard: 'Edetabel',
      rewards: 'Boonused',
    },
  },
  
  // User segments
  segments: {
    advanced: 'Advanced kasutaja',
    professional: 'Professional kasutaja',
    standard: 'Tavakasutaja',
  },
  
  // Membership tiers
  tiers: {
    bronze: 'Pronks',
    silver: 'Hõbe',
    gold: 'Kuld',
    platinum: 'Plaatina',
    regular: 'Tavaline',
  },
  
  // Profile page
  profile: {
    membershipBadge: 'Liikmelisuse märk',
    pointsToNextTier: 'punkti järgmise tasemeni',
    recentRewards: 'Viimased boonused',
    redeemed: 'Ostetud',
  },
  
  // Home page
  home: {
    pointsEarned: 'Teenitud punktid',
    achievementUnlocked: 'Saavutus avatud',
    pointsFromPurchase: '+{points} punkti viimase ostu eest',
    reachedTop3: 'Jõudsite edetabeli top 3 hulka',
  },
  
  // Leaderboard page
  leaderboard: {
    switchUser: 'Vaheta kasutajat',
    rank: 'Koht',
    pts: 'punkti',
    noData: 'Edetabeli andmeid pole saadaval',
    anonymous: 'Anonüümne',
  },
  
  // Rewards page
  rewards: {
    availableRewards: 'Saadaval',
    allRewards: 'Kõik',
    redeemedRewards: 'Ostetud',
    questProgress: '{progress}/{target} tehtud',
    notStarted: 'Alustamata',
    quests: 'Ülesanded',
    storeCredit: 'Raha',
    foodBeverage: 'Toit ja jook',
    membership: 'Liikmelisus',
    other: 'Muu',
    redeem: 'Osta',
    redeeming: 'Toimetan...',
    redeemSuccess: 'Valmis!',
    redeemFail: 'Boonuse ostmine ebaõnnestus',
    notEnoughPoints: 'Pole piisavalt punkte',
    noRewardsAvailable: 'Boonused puuduvad',
    termsAndConditions: 'Tingimused',
    termsDescription: 'Boonus tuleb kasutada 30 päeva jooksul. Ei saa kombineerida teiste pakkumistega.',
    progress: 'Edenemine',
    reward: 'Boonus',
    completeQuestToEarn: 'Punktide teenimiseks lõpeta see ülesanne!',
  },
  
  // User switcher component
  userSwitcher: {
    switchUser: 'Vaheta kasutajat',
  },
  
  // Activity descriptions
  activity: {
    purchasePoints: '+{points} punkti viimase ostu eest',
    leaderboardAchievement: 'Jõudsite edetabeli top 3 hulka',
  },
  
  // Date formatting
  dateFormat: {
    dayAgo: '{n} päev tagasi',
    daysAgo: '{n} päeva tagasi',
    today: 'Täna',
    yesterday: 'Eile',
  },
  
  // Language
  language: {
    en: 'Inglise',
    et: 'Eesti',
  },
} 